import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<'privacy' | 'terms'>('privacy');
  const openModal = (type: 'privacy' | 'terms') => {
    setModalContent(type);
    setModalOpen(true);
  };
  const privacyContent = <>
      <p data-id="element-149">
        <strong data-id="element-150">1. Information We Collect</strong>
        <br data-id="element-151" />
        We collect information necessary to process your purchase and deliver
        the digital product, including your name and email address. We do not
        store complete financial information.
      </p>

      <p data-id="element-152">
        <strong data-id="element-153">2. Use of Information</strong>
        <br data-id="element-154" />
        We use your information solely to deliver the product, send related
        updates, and improve our services.
      </p>

      <p data-id="element-155">
        <strong data-id="element-156">3. Data Protection</strong>
        <br data-id="element-157" />
        We implement industry-standard security measures to protect your
        personal information against unauthorized access.
      </p>

      <p data-id="element-158">
        <strong data-id="element-159">4. Cookies</strong>
        <br data-id="element-160" />
        We use essential cookies for the shopping cart functionality and
        anonymous traffic analysis.
      </p>
    </>;
  const termsContent = <>
      <p data-id="element-161">
        <strong data-id="element-162">1. Acceptance</strong>
        <br data-id="element-163" />
        By purchasing this product, you agree to these terms and conditions in
        their entirety.
      </p>

      <p data-id="element-164">
        <strong data-id="element-165">2. Digital Product</strong>
        <br data-id="element-166" />
        "The Knee Geometry Method" is a 100% digital product. No physical
        product will be shipped.
      </p>

      <p data-id="element-167">
        <strong data-id="element-168">3. Refund Policy</strong>
        <br data-id="element-169" />
        We offer a 30-day satisfaction guarantee. If you are not satisfied, you
        may request a full refund within this period.
      </p>

      <p data-id="element-170">
        <strong data-id="element-171">4. Intellectual Property</strong>
        <br data-id="element-172" />
        All content is protected by copyright. Redistribution or resale is
        strictly prohibited.
      </p>

      <p data-id="element-173">
        <strong data-id="element-174">5. Medical Disclaimer</strong>
        <br data-id="element-175" />
        The author is not responsible for misuse of the information provided.
        This guide is for educational purposes and does not replace professional
        medical advice.
      </p>
    </>;
  return <>
      <footer className="bg-[#F5F5F0] text-[#666] text-center py-12 px-5 text-[11px] font-sans border-t border-[#E5E5E0]" data-id="element-176">
        <div className="max-w-[680px] mx-auto" data-id="element-177">
          <p className="mb-6 font-bold text-[#1a1a1a] uppercase tracking-wider" data-id="element-178">
            Wellness Daily
          </p>

          <div className="flex justify-center gap-6 mb-6" data-id="element-179">
            <button onClick={() => openModal('privacy')} className="hover:text-[#1a1a1a] transition-colors" data-id="element-180">
              Privacy Policy
            </button>
            <button onClick={() => openModal('terms')} className="hover:text-[#1a1a1a] transition-colors" data-id="element-181">
              Terms & Conditions
            </button>
          </div>

          <p className="mb-4 text-[#888]" data-id="element-182">© 2026 - The Knee Geometry Method</p>

          <p className="text-[10px] text-[#999] leading-relaxed max-w-[500px] mx-auto" data-id="element-183">
            Disclaimer: This content is for educational purposes only. It is not
            intended to substitute for professional medical advice, diagnosis,
            or treatment. Always seek the advice of your physician or other
            qualified health provider with any questions you may have regarding
            a medical condition.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={modalContent === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'} content={modalContent === 'privacy' ? privacyContent : termsContent} data-id="element-184" />
    </>;
}